// SiteFloorStack — page wrapper (formerly "Floor Stack", now 樓層檢視).
//
// /dashboard/sites/:siteId/floor-stack
//
// Pulls site name + brand_primary from the floor-stack response so the
// header reflects per-tenant / per-site brand. Delegates to
// FloorStackContainer. Route path keeps `/floor-stack` for URL stability;
// only the user-visible label was renamed (2026-05: 樓層預覽 → 樓層檢視 to match spec).

import React from "react";
import { Link, useParams } from "react-router-dom";
import { Layers as LayersIcon } from "lucide-react";
import PageHeader from "../components/PageHeader.js";
import FloorStackContainer from "../floor-stack/FloorStackContainer.js";
import { useDashboardSession } from "../auth/useDashboardSession.js";

export default function SiteFloorStack(): React.ReactElement {
  const { siteId = "" } = useParams<{ siteId: string }>();
  const session = useDashboardSession();
  const tenantParam = session.super_admin ? session.acting_tenant_id ?? null : null;

  return (
    <div data-testid="site-floor-stack">
      <PageHeader
        title="樓層檢視"
        description="多樓層中控視覺：hover 看摘要、點擊展開進入單層中控視圖（支援 2D / 3D 切換）。"
        actions={
          <>
            <Link to={`/dashboard/sites/${siteId}/layout`} className="btn-secondary inline-flex items-center gap-1.5">
              <LayersIcon className="h-3.5 w-3.5" />
              編輯圖資
            </Link>
            <Link to="/dashboard/sites" className="btn">回案場列表</Link>
          </>
        }
      />
      <FloorStackContainer siteId={siteId} tenantId={tenantParam} />
    </div>
  );
}
